{
  "CalloutCreateModal": {
    "createCallout": "创建标注",
    "editCallout": "编辑标注",
    "duplicateCallout": "复制标注",
    "callout": "标注",
    "couldNotCreateCallout": "无法创建标注",
    "couldNotUpdateCallout": "无法更新标注",
    "details": "详情",
    "title": "标题",
    "titlePlaceholder": "为假日拍摄招募演员...",
    "defaultResourceType": "默认资源类型",
    "selectResourceTypeInfo": "选择添加申请人时将设置的资源类型",
    "resourceType": "资源类型",
    "resourceTypePlaceholder": "选择资源类型",
    "resourceTypeRequired": "请选择资源类型",
    "template": "模板",
    "templateInfo": "这将为您提供一个建议的字段集以供开始和编辑",
    "cancel": "取消",
    "saveChanges": "保存更改"
  },
  "CalloutDetail": {
    "build": "构建",
    "preview": "预览",
    "publish": "发布",
    "applicants": "申请人",
    "backToEdit": "返回编辑",
    "unpublishAndEdit": "取消发布并编辑",
    "unpublishAndEditTip": "取消发布标注以进行编辑"
  },
  "CalloutActions": {
    "share": "分享",
    "duplicate": "复制",
    "edit": "编辑",
    "editCallout": "编辑标注",
    "transfer": "转移到工作区",
    "archive": "归档",
    "unarchive": "取消归档",
    "moreActions": "更多操作",
    "archiveSuccess": "标注已归档",
    "unarchiveSuccess": "标注已取消归档",
    "archiveError": "归档标注失败：{{error}}",
    "unarchiveError": "取消归档标注失败：{{error}}"
  },
  "CalloutDialog": {
    "createCallout": "创建标注",
    "editCallout": "编辑标注",
    "duplicateCallout": "复制标注",
    "duplicate": "复制",
    "details": "详情",
    "template": "模板",
    "templateInfo": "这将为您提供一个建议的字段集以供开始和编辑",
    "slug": "URL 别名",
    "slugInvalid": "仅使用小写字母、数字和连字符",
    "slugRequired": "别名为必填项",
    "slugSyncFromTitle": "与标题同步",
    "slugUuidDisallowed": "别名不能是 UUID 格式",
    "slugDuplicate": "该别名已被使用",
    "next": "下一步",
    "back": "返回",
    "backWithArrow": "← 返回",
    "cancel": "取消",
    "create": "创建标注",
    "saveChanges": "保存更改",
    "selectTemplate": "选择模板",
    "selectTemplateHint": "选择一个模板",
    "templateSelectedCount": "已选择 {{count}} 项",
    "unselectAll": "取消全选",
    "unselectAllTemplates": "取消选择所有模板",
    "templateFieldCount": "{{count}} 个字段",
    "couldNotCreateCallout": "无法创建标注",
    "couldNotUpdateCallout": "无法更新标注"
  },
  "templates": {
    "basicCallout": {
      "name": "💁🏽‍♂️️ 基本标注",
      "description": "用于收集联系信息的基本表单",
      "mappings": {
        "full_name": {
          "label": "全名",
          "description": ""
        },
        "emails": {
          "label": "电子邮件",
          "description": ""
        },
        "phone_number": {
          "label": "电话号码",
          "description": ""
        },
        "websites": {
          "label": "网站链接 (URL)",
          "description": ""
        },
        "locations": {
          "label": "地址",
          "description": "搜索并选择下方的地址"
        }
      }
    },
    "portfolioCallout": {
      "name": "📸 作品集标注",
      "description": "用于收集联系信息和作品样本的表单",
      "mappings": {
        "full_name": {
          "label": "全名",
          "description": ""
        },
        "emails": {
          "label": "电子邮件",
          "description": ""
        },
        "phone_number": {
          "label": "电话号码",
          "description": ""
        },
        "websites": {
          "label": "网站",
          "description": ""
        },
        "locations": {
          "label": "地点",
          "description": "你在哪里？"
        },
        "files": {
          "label": "上传样本",
          "description": "至少上传三个工作样本"
        }
      }
    },
    "modelCallout": {
      "name": "⭐️ 模特标注",
      "description": "用于收集选角模特信息的表单",
      "mappings": {
        "full_name": {
          "label": "全名",
          "description": ""
        },
        "emails": {
          "label": "电子邮件",
          "description": "请输入您本人或经纪人的邮箱地址"
        },
        "phone_number": {
          "label": "电话号码",
          "description": "请输入您本人或经纪人的电话"
        },
        "websites": {
          "label": "网站链接 (URL)",
          "description": "您的作品集链接"
        },
        "social_instagram": {
          "label": "Instagram",
          "description": "如果您有相关的Instagram账号，请输入账号名"
        },
        "locations": {
          "label": "地点",
          "description": "你在哪里？"
        },
        "files": {
          "label": "作品集图片",
          "description": "至少上传3张之前工作的图片"
        }
      }
    }
  },
  "fieldMappings": {
    "social_instagram": "Instagram",
    "social_twitter": "Twitter",
    "social_behance": "Behance",
    "social_youtube": "YouTube",
    "social_vimeo": "Vimeo",
    "profile_picture": "头像",
    "full_name": "全名",
    "files": "媒体上传器",
    "role": "角色",
    "websites": "网站",
    "emails": "电子邮件",
    "phone_numbers": "电话号码",
    "locations": "位置",
    "rates": "费率",
    "tags": "标签",
    "groups": "组"
  },
  "CalloutForm": {
    "termsSection": "条款与条件",
    "termsTitle": "条款与条件",
    "termsTitlePlaceholder": "条款与条件标题",
    "termsContentPlaceholder": "条款与条件内容",
    "termsCheckboxLabelPlaceholder": "确认文本",
    "termsPrivacyNotice": "隐私声明：提交此申请即表示您同意我们为选角和预订目的收集和处理您的个人信息。您的信息将用于评估您是否适合我们的项目，并可能与我们的制作合作伙伴共享。参与是自愿的，您可以随时通过联系我们撤回申请。我们致力于保护您的隐私，并将根据适用的隐私法处理您的数据。",
    "termsRequired": "您必须同意条款与条件",
    "termsCheckboxLabel": "我同意上述条款与条件",
    "submitError": "提交表单时出错，请重试。",
    "submitting": "提交中...",
    "submitApplication": "提交申请",
    "successTitle": "已提交申请",
    "successMessage": "感谢您的申请。如果我们认为您适合我们的项目，我们会与您联系。",
    "submitAnother": "提交另一份申请"
  },
  "ApplicantSubmittedModal": {
    "title": "已提交申请",
    "thanksMessage": "感谢您的提交，我们将很快联系您",
    "successMessage": "感谢您的申请。如果我们认为您适合我们的项目，我们会与您联系。",
    "submitAnother": "提交另一份申请"
  },
  "CalloutFormControls": {
    "invalidEmail": "邮箱地址无效",
    "locationPlaceholder": "选择位置",
    "locationSearchPrompt": "搜索位置",
    "locationEmpty": "未找到位置",
    "locationUseTypedText": "使用“<query></query>”"
  },
  "CalloutBuilderField": {
    "dragToReorder": "拖动以重新排序：{{name}}",
    "labelPlaceholder": "添加标签",
    "descriptionPlaceholder": "添加描述",
    "required": "必填",
    "remove": "删除字段：{{name}}"
  },
  "TransferCalloutDialog": {
    "title": "转移到工作区",
    "description_one": "将 {{name}} 移动到另一个工作区。",
    "description_other": "将 {{count}} 个标注移动到另一个工作区。",
    "fieldWorkspace": "目标工作区",
    "success_one": "标注已转移",
    "success_other": "已转移 {{count}} 个标注"
  }
}
